/* eslint-disable react/display-name */
/**
 * @file Medical ParametersManagementView.jsx
 * @author Fernando Ruano
 * @description Medical Parameters Management View Page
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Helpers
import { sortString } from '@nephro/commons/helpers/utils';

// Components
import ManagementCrud from '@nephro/components/ManagementCrud';

/**
 * Medical Parameters Management View
 * @param { Object } parameterActions - Medical Parameter Actions.
 * @return { Node } React node.
 */
function MedicalParametersManagementView({ medicalParameterActions }) {
  const { t: translate } = useTranslation();
  const { getMedicalParametersArray, deleteMedicalParameterById } =
    medicalParameterActions;

  // Table columns
  const columns = [
    {
      title: translate('paramMg.key'),
      dataIndex: 'param_key',
      sorter: sortString('param_key')
    },
    {
      title: translate('paramMg.value'),
      dataIndex: 'param_value',
      sorter: sortString('param_value')
    },
    {
      title: translate('commons.description'),
      dataIndex: 'param_description',
      sorter: sortString('param_description')
    }
  ];

  return (
    <div className="h-full">
      <ManagementCrud
        getItemsArray={getMedicalParametersArray}
        deleteItemById={deleteMedicalParameterById}
        columns={columns}
        deleteConfirmText={'paramMg.deleteParameter'}
        createButtonText={'paramMg.create'}
        itemIdKey={'id'}
      />
    </div>
  );
}

/**
 * Component definition of proptypes.
 */
MedicalParametersManagementView.propTypes = {
  actions: PropTypes.shape({
    setLoading: PropTypes.func.isRequired
  }).isRequired,
  medicalParameterActions: PropTypes.shape({
    getMedicalParametersArray: PropTypes.func.isRequired,
    deleteMedicalParameterById: PropTypes.func.isRequired
  }).isRequired,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
  loading: PropTypes.bool
};

export default MedicalParametersManagementView;
